import styled from 'styled-components';

export const Container = styled.header`
  width: 100%;
  position: fixed;
  padding: 20px 0;
  z-index: 3;
  background-color: ${({ theme }) => theme.colors.grey.black};

  &::before {
    content: '';
    width: 100%;
    height: 8px;
    position: absolute;
    bottom: 0;
    background: ${({ theme }) => theme.colors.gradient.fullX};

    @media ${({ theme }) => theme.devices.mobile} {
      display: none;
    }
  }

  > div {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  @media ${({ theme }) => theme.devices.notebook} {
    .desktop {
      display: none;
    }
    .mobile {
      display: flex;
    }

    > div {
      > a {
        img {
          width: 100%;
          max-width: 140px;
        }
      }
    }
  }

  @media ${({ theme }) => theme.devices.mobile} {
    padding: 0;
    padding-top: 12px;
  }
`;
